module.exports = __webpack_public_path__ + "static/media/30OIOS3.6e9021e4.jpg";